// src/dashboard/pages/teacher/Techniques/components/TechniqueMobileCards.jsx

import React from "react";
import { FaEdit, FaTrash, FaVideo } from "react-icons/fa";

import {
  getTechniquePhotoSrc,
  DEFAULT_TECHNIQUE_IMAGE,
} from "../utils/techniquesDashboardUtils";

export default function TechniqueMobileCards({
  items = [],
  onEdit,
  onDelete,
  deletingId,
}) {
  return (
    <div className="space-y-3 md:hidden">
      {items.map((technique) => {
        const hasVideo = !!String(technique.video_url || "").trim();
        const hasUv2 = !!String(technique.uv2 || "").trim();

        return (
          <article
            key={`mobile-${technique.id}`}
            className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900/60"
          >
            <div className="flex gap-3 p-3">
              <img
                src={getTechniquePhotoSrc(technique.image1_url)}
                alt={technique.nom || "Technique"}
                className="h-24 w-24 shrink-0 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                onError={(event) => {
                  event.currentTarget.src = DEFAULT_TECHNIQUE_IMAGE;
                }}
              />

              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-slate-900 dark:text-white">
                  {technique.nom || "—"}
                </h3>

                {technique.traduction ? (
                  <p className="mt-0.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                    {technique.traduction}
                  </p>
                ) : null}

                <div className="mt-2 flex flex-wrap gap-2">
                  <span className="inline-flex rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-300">
                    {technique.famille || "—"}
                  </span>

                  <span className="inline-flex rounded-full bg-indigo-50 px-2.5 py-1 text-[11px] font-bold text-indigo-700 ring-1 ring-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20">
                    {technique.ceinture || "—"}
                  </span>
                </div>

                <div className="mt-2 flex flex-wrap gap-2">
                  {hasVideo ? (
                    <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-[11px] font-bold text-rose-700 ring-1 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-500/20">
                      <FaVideo />
                      Vidéo
                    </span>
                  ) : null}

                  {hasUv2 ? (
                    <span className="inline-flex rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-bold text-emerald-700 ring-1 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20">
                      UV2
                    </span>
                  ) : null}
                </div>

                {technique.information ? (
                  <p className="mt-2 line-clamp-2 text-xs leading-5 text-slate-600 dark:text-slate-300">
                    {technique.information}
                  </p>
                ) : null}

                <div className="mt-3 flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => onEdit(technique)}
                    className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
                  >
                    <FaEdit />
                    Modifier
                  </button>

                  <button
                    type="button"
                    onClick={() => onDelete(technique)}
                    disabled={deletingId === technique.id}
                    className="inline-flex items-center justify-center gap-2 rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-xs font-bold text-rose-700 transition hover:bg-rose-100 disabled:opacity-50 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
                  >
                    <FaTrash />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}